import type { Components, Theme } from "@mui/material";

export const dividerTheme: Components<Theme>["MuiDivider"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.divider}`,
    }),
  },
};
